import React, { createContext, useReducer } from 'react';
import Reducer from './Reducer.js';
import PropTypes from 'prop-types';

const initialState = {
  sessionChecked: false,
  organizationAccess: [],
  newScores: {},
  budgetOrder: null,
  generatedDocuments: null,
  generatingDocument: false,
  theme: '',
  navDrawerOpen: true,
  loading: false,
  loaderMessage: '',
  keepBudgetAccessForUsersActive: false,
  saveUnsavedChanges: false,
  fireUnsavedChangesDialog: false,
  discardUnsavedChanges: false,
  userNavigated: false,
  disabledUnsavedChangesDialogSaveButton: false,
  triggerSave: false,
  triggerDiscard: false,
  refreshDrawerHard: false,
  refreshRequests: false,
  refreshGroups: false,
  refreshOrganizationAccess: false,
  goalsProgress: {},
  insightData: {},
  backButtonFired: false,
  changesWereMade: false,
  isDirty: false,
  download: false,
  budgetSuccessfullyUploaded: false,
  programCountForActiveBudget: null,
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
};

export const Context = createContext(initialState);
export default Store;

Store.propTypes = {
  children: PropTypes.node,
};
